"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturesStore = void 0;
/**
 * Represents the Features store responsible for fetching
 * remote Features from the server.
 *
 * It uses an Axios http client to fetch data from our public
 * web endpoints.
 */
class FeaturesStore {
    httpClient;
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Fetches all features assignments given a list of [EvaluationCriteria]
     * through our public web interface.
     * On error, the error is logged and this method will return a list of
     * null assignments.
     *
     * @param evaluationCriterias the list of EvaluationCriteria to get [FeatureAssignment] for
     * @return The list of FeatureAssignments.
     */
    fetchAssignments(evaluationCriterias, hydrateTargetingProperties) {
        const queryParams = this.buildFetchAssignmentsQueryParams(hydrateTargetingProperties);
        return this.httpClient
            .post('/v1/features/client/evaluate', {
            criteria: evaluationCriterias,
        }, { params: queryParams })
            .then((res) => res.data.assignments)
            .catch((err) => {
            console.warn('Error evaluating features via edge-core-api', err);
            return evaluationCriterias.map((e) => this.newNullAssignment(e));
        });
    }
    /**
     * Builds a null value FeatureAssignment object corresponding to the
     * provided EvaluationCriteria object.
     * @param evaluationCriteria An EvaluationCriteria object
     * @return A null value FeatureAssignment object.
     */
    newNullAssignment(evaluationCriteria) {
        return {
            featureKey: evaluationCriteria.featureKey,
            subjectKey: evaluationCriteria.subjectKey,
            reportable: false,
        };
    }
    buildFetchAssignmentsQueryParams(hydrateTargetingProperties) {
        if (!hydrateTargetingProperties)
            return undefined;
        return { hydrateTargetingProperties };
    }
}
exports.FeaturesStore = FeaturesStore;
